import { render, staticRenderFns } from "./DialogAuthorizationMyAcuvue.vue?vue&type=template&id=b1639dea&scoped=true&"
import script from "./DialogAuthorizationMyAcuvue.vue?vue&type=script&lang=js&"
export * from "./DialogAuthorizationMyAcuvue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1639dea",
  null
  
)

export default component.exports